type TypePage<T> = { items: T[] };

export function opsPagesUpsert<T>(pages: TypePage<T>[], incoming: readonly T[], keyOf: (item: T) => string, accept: (item: T) => boolean): void {
    if (!pages.length) return;

    for (const item of incoming) {
        const key = keyOf(item);
        const keep = accept(item);
        let found = false;

        for (const page of pages) {
            const index = page.items.findIndex((entry) => keyOf(entry) === key);
            if (index === -1) continue;
            found = true;
            if (keep) page.items[index] = item;
            else page.items.splice(index, 1);
            break;
        }

        if (!found && keep) pages[0].items.unshift(item);
    }
}

export default opsPagesUpsert;
